
      var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 27,
  height: 29,
  textRendering: "geometricPrecision",
  viewBox: "0 0 27 29"
}, props), _image || (_image = /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAdCAMAAABsU+d6AAAAe1BMVEXjAYfiAofjAobjAYfhAofjAYbfAIdMaXHjA4fiAYbfAH/jAobjAobkAobfAIrjAobjAIjkAITiAYbiAojiAYfiAobfAH/jAofiAYbjAobhAIniA4bjAYbjAYfiAYfiAYfjAojiAYbjAIjjAYbiAYfjAofiAofjAYfjAYb7HcfiAAAAKXRSTlOAz8O3YJ8gAEC/EHDfaBjLODC7WLPHCNuH5zRIp5OPq3ijHJuX79evgxw/mx8AAAAJcEhZcwAAA+gAAAPoAbV7UmsAAADKSURBVHjatZLrDsIgDIXbDlbA3Z1T5/3u+z+hwOSXIyYunpCPhhPa5AAw101j2KlrqfIFXyi3BLsUKH9id/DFWbP2XoUKUDshqMwXC823q2HIt7uPe6lmEsRQGkVl4Y8MlZthXkvApx40R2Sb/OqhikgqyCAi/W1eN9axGLx0KaU8OCQYQOLtSReF9MEEiKne2kXvgFnA/Z/z0Ca0d5A64BG8xOYwd5jJgNXUedGexGbs9Wp+Kkj6yPthATWCGFFufyFwkY/1PFbML47WFK/TMf7nAAAAAElFTkSuQmCC",
  width: 27,
  height: 29,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAdCAMAAABsU+d6AAAAe1BMVEXjAYfiAofjAobjAYfhAofjAYbfAIdMaXHjA4fiAYbfAH/jAobjAobkAobfAIrjAobjAIjkAITiAYbiAojiAYfiAobfAH/jAofiAYbjAobhAIniA4bjAYbjAYfiAYfiAYfjAojiAYbjAIjjAYbiAYfjAofiAofjAYfjAYb7HcfiAAAAKXRSTlOAz8O3YJ8gAEC/EHDfaBjLODC7WLPHCNuH5zRIp5OPq3ijHJuX79evgxw/mx8AAAAJcEhZcwAAA+gAAAPoAbV7UmsAAADKSURBVHjatZLrDsIgDIXbDlbA3Z1T5/3u+z+hwOSXIyYunpCPhhPa5AAw101j2KlrqfIFXyi3BLsUKH9id/DFWbP2XoUKUDshqMwXC823q2HIt7uPe6lmEsRQGkVl4Y8MlZthXkvApx40R2Sb/OqhikgqyCAi/W1eN9axGLx0KaU8OCQYQOLtSReF9MEEiKne2kXvgFnA/Z/z0Ca0d5A64BG8xOYwd5jJgNXUedGexGbs9Wp+Kkj6yPthATWCGFFufyFwkY/1PFbML47WFK/TMf7nAAAAAElFTkSuQmCC",
  preserveAspectRatio: "none"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"27\" height=\"29\" text-rendering=\"geometricPrecision\" viewBox=\"0 0 27 29\"><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAdCAMAAABsU+d6AAAAe1BMVEXjAYfiAofjAobjAYfhAofjAYbfAIdMaXHjA4fiAYbfAH/jAobjAobkAobfAIrjAobjAIjkAITiAYbiAojiAYfiAobfAH/jAofiAYbjAobhAIniA4bjAYbjAYfiAYfiAYfjAojiAYbjAIjjAYbiAYfjAofiAofjAYfjAYb7HcfiAAAAKXRSTlOAz8O3YJ8gAEC/EHDfaBjLODC7WLPHCNuH5zRIp5OPq3ijHJuX79evgxw/mx8AAAAJcEhZcwAAA+gAAAPoAbV7UmsAAADKSURBVHjatZLrDsIgDIXbDlbA3Z1T5/3u+z+hwOSXIyYunpCPhhPa5AAw101j2KlrqfIFXyi3BLsUKH9id/DFWbP2XoUKUDshqMwXC823q2HIt7uPe6lmEsRQGkVl4Y8MlZthXkvApx40R2Sb/OqhikgqyCAi/W1eN9axGLx0KaU8OCQYQOLtSReF9MEEiKne2kXvgFnA/Z/z0Ca0d5A64BG8xOYwd5jJgNXUedGexGbs9Wp+Kkj6yPthATWCGFFufyFwkY/1PFbML47WFK/TMf7nAAAAAElFTkSuQmCC\" width=\"27\" height=\"29\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAdCAMAAABsU+d6AAAAe1BMVEXjAYfiAofjAobjAYfhAofjAYbfAIdMaXHjA4fiAYbfAH/jAobjAobkAobfAIrjAobjAIjkAITiAYbiAojiAYfiAobfAH/jAofiAYbjAobhAIniA4bjAYbjAYfiAYfiAYfjAojiAYbjAIjjAYbiAYfjAofiAofjAYfjAYb7HcfiAAAAKXRSTlOAz8O3YJ8gAEC/EHDfaBjLODC7WLPHCNuH5zRIp5OPq3ijHJuX79evgxw/mx8AAAAJcEhZcwAAA+gAAAPoAbV7UmsAAADKSURBVHjatZLrDsIgDIXbDlbA3Z1T5/3u+z+hwOSXIyYunpCPhhPa5AAw101j2KlrqfIFXyi3BLsUKH9id/DFWbP2XoUKUDshqMwXC823q2HIt7uPe6lmEsRQGkVl4Y8MlZthXkvApx40R2Sb/OqhikgqyCAi/W1eN9axGLx0KaU8OCQYQOLtSReF9MEEiKne2kXvgFnA/Z/z0Ca0d5A64BG8xOYwd5jJgNXUedGexGbs9Wp+Kkj6yPthATWCGFFufyFwkY/1PFbML47WFK/TMf7nAAAAAElFTkSuQmCC\" preserveAspectRatio=\"none\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/calendar.1707ac7ec4efc0a38c5f8693a8ea8531.svg"),
        {
          React: SvgCalendar,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      